'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
cbStripContactController.$inject = ['$window', '$attrs', 'BreakpointsConstants'];
var _module = angular.module('cb.strips.cb-strip-contact-v1.cbStripContactController', []);

_module.controller('cbStripContactController', cbStripContactController);

exports.default = _module;


function cbStripContactController($window, $attrs, BreakpointsConstants) {
    var vm = this;
    vm.toggleContactOptions = toggleContactOptions;

    vm.$onInit = function () {
        // if on tablet or desktop expand 1 item
        if ($window.innerWidth >= BreakpointsConstants.sm) {
            toggleContactOptions($attrs.cbStripContactV1);
        }
    };

    function toggleContactOptions(option) {
        vm.cardActive = option;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/contact-v1/contact.controller.js
// module id = 933
// module chunks = 1